import { createAsyncThunk } from '@reduxjs/toolkit'
import moment from 'moment'
import { dashboardServices } from '@services'
import { DINING_METHOD } from '@common'
import { organizeMenus, isRegularMember } from '../selectors'

export const fetchMenus = createAsyncThunk('dashboard/fetchMenus', async (_, thunk) => {
    try {
        const res = await dashboardServices.fetchMenus()

        if (res.error) {
            return thunk.rejectWithValue(res.error)
        }

        // Build reference moment when Advance Takeaway is selected
        const state = thunk.getState()
        const userState = state?.user || {}
        const { diningMethod, pickupDate, pickupTime } = userState

        let referenceMoment = null
        if (diningMethod?.value === DINING_METHOD.AdvanceTakeaway && pickupDate && pickupTime) {
            // Combine date and time to a moment for evaluation (assume HH:mm format for time)
            referenceMoment = moment(`${pickupDate} ${pickupTime}`, 'YYYY-MM-DD HH:mm')
        }

        // Check if member is regular member (only Member role, no other roles)
        const memberData = state?.membership?.memberData || {}
        const isRegularMemberValue = isRegularMember(memberData)

        const { categories, filteredMenus } = organizeMenus(res.menus, {
            referenceMoment: referenceMoment || undefined,
            isRegularMember: isRegularMemberValue,
        })

        return { categories, filteredMenus }
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const fetchCafeConfig = createAsyncThunk('dashboard/fetchCafeConfig', async (_, thunk) => {
    try {
        const response = await dashboardServices.fetchCafeConfig()

        if (response.error) {
            return thunk.rejectWithValue(response.error)
        }

        return response.cafe[0]
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const fetchCafeCashRegisters = createAsyncThunk('dashboard/fetchCafeCashRegisters', async (_, thunk) => {
    try {
        const res = await dashboardServices.fetchCafeCashRegisters()

        if (res.error) {
            return thunk.rejectWithValue('Invalid cafe id')
        }

        return res
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const fetchCafeGroups = createAsyncThunk('dashboard/fetchCafeGroups', async (_, thunk) => {
    try {
        const res = await dashboardServices.fetchCafeGroups()

        if (res.error) {
            return thunk.rejectWithValue('Invalid cafe id')
        }

        return res
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})
